import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import "./assets/vendor/bootstrap/css/bootstrap.min.css";
import "./assets/vendor/bootstrap-icons/bootstrap-icons.css";
import "./assets/vendor/aos/aos.css";
import "./assets/vendor/glightbox/css/glightbox.min.css";
import "./assets/vendor/swiper/swiper-bundle.min.css";
import "./assets/css/styless.css";

import "./assets/vendor/bootstrap/js/bootstrap.bundle.min.js";

import { createPinia } from "pinia";
import piniaPersistedstate from "pinia-plugin-persistedstate";

import Particles from "vue3-particles";

const app = createApp(App);

// Pinia correcto (más claro)
const pinia = createPinia();
pinia.use(piniaPersistedstate);

app.use(router);
app.use(Particles);
app.use(pinia);

app.mount("#app");
